import { render, staticRenderFns } from "./personalised-header.vue?vue&type=template&id=2f796a2a&"
import script from "./personalised-header.vue?vue&type=script&lang=js&"
export * from "./personalised-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports